module.exports = __webpack_public_path__ + "static/img/at_4.4df1e57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/at_4.jpg
// module id = fDhj
// module chunks = 1